import { render, staticRenderFns } from "./RecipientDetails.vue?vue&type=template&id=e9e3bc06&scoped=true&"
import script from "./RecipientDetails.vue?vue&type=script&lang=js&"
export * from "./RecipientDetails.vue?vue&type=script&lang=js&"
import style0 from "./RecipientDetails.vue?vue&type=style&index=0&id=e9e3bc06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e3bc06",
  null
  
)

export default component.exports